/* eslint-disable no-case-declarations */
/* eslint-disable no-console */
/* eslint-disable no-param-reassign */

import { OrderAction, OrderActionTypes, OrderState } from './types';

const INITIAL_STATE: OrderState = {
  orders: {
    current_page: 0,
    first_page_url: '',
    last_page: 0,
    last_page_url: '',
    next_page_url: '',
    orders: [],
    path: '',
    per_page: 0,
    prev_page_url: '',
    to: 0,
    total: 0,
  },
  error: false,
  loading: false
};

export default function Checkout(
  state = INITIAL_STATE,
  action: OrderAction,
): OrderState {
  switch (action.type) {
    case OrderActionTypes.ORDER_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case OrderActionTypes.ORDER_LIST_SUCCESS:
      return {
        ...state,
        orders: action.payload.order,
        loading: false,
        error: true,
      };

    case OrderActionTypes.ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case OrderActionTypes.ORDER_SUCCESS:
      return {
        ...state,
        order: action.payload.order,
        loading: false,
        error: true,
      };
    case OrderActionTypes.ORDER_CANCEL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case OrderActionTypes.ORDER_CANCEL_SUCCESS:
      return {
        ...state,
        order: action.payload.order,
        loading: false,
        error: false,
      };
    case OrderActionTypes.ORDER_CLEAR:
      return {
        ...state,
        order: {},
        loading: false,
        error: true,
      };
    case OrderActionTypes.CLEAR_LOADING:
      return {
        ...state,
        loading: false,
      }
    default:
      return state;
  }
}
